import { AutomationChannel } from "@redotech/redo-model/advanced-flow/common";
import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import type { AiContextLibrary } from "@redotech/redo-model/ai-context-library";
import {
  AiContextLibrarySchema,
  AiContextLibraryType,
  qualityValues,
} from "@redotech/redo-model/ai-context-library";
import * as z from "zod/v4";

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const SchemaTypeValues = Object.values(SchemaType) as [
  SchemaType,
  ...SchemaType[],
];

export const createContextLibraryItem = {
  name: "createContextLibraryItem" as const,
  input: z.object({
    type: z.literal(AiContextLibraryType.MARKETING),
    title: z.string(),
    content: z.string(),
    triggerType: z.enum(SchemaTypeValues),
    strategy: z.string(),
    channel: z.enum(AutomationChannelValues),
    quality: z.enum(qualityValues),
    feedback: z.string().optional(),
  }),
  output: AiContextLibrarySchema as z.ZodType<AiContextLibrary>,
};
